module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAUCAYAAACnOeyiAAAAKklEQVQImWP8//+/DQMDwwsmBgYGfgYGBk4mBigYbAzG////czEwMPwBAA2PCGOslfToAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/vertical-line-index.png
// module id = 1057
// module chunks = 2